import { render, staticRenderFns } from "./CreateBooking.vue?vue&type=template&id=32f3bbf4&scoped=true&"
import script from "./CreateBooking.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateBooking.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CreateBooking.vue?vue&type=style&index=0&id=32f3bbf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f3bbf4",
  null
  
)

export default component.exports